import { Button, Form, Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import MediaManager from '../../Media/MediaManager';
import { useForm } from 'antd/es/form/Form';
import { useManufacturer } from './ManufacturerStore';
import { useCountries } from '../Countrys/CountryStore';

function Edit(props) {
    let { updateManufacturer, ed } = useManufacturer()
    let {countries, getCountries} = useCountries()
    let [logo, setLogo] = useState(null)
    let [previewVisible, setPreviewVisible] = useState(false)
    let handleSelect = (e) => {
        setLogo(e)
    }
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue({
            logo: logo
        })
    }, [logo])

    useEffect(() => {
        getCountries()
    }, [])
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <>
            <Modal width={'80%'} open={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
                <MediaManager onSelect={handleSelect} />
            </Modal>
            <Form form={form} layout="vertical" onFinish={updateManufacturer} encType="multipart/form-data">
                <Form.Item name={'id'} hidden>
                    <Input readOnly />
                </Form.Item>
                <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Logo" name="logo">
                    <Input  readOnly defaultValue={logo} suffix={<Button type="primary" onClick={() => setPreviewVisible(true)}>Fayl yuklash</Button>} />
                </Form.Item>
                <Form.Item label="Davlat" name="country_id">
                    <Select options={countries.map(country => ({ label: country.nameuz, value: country.id }))} showSearch optionFilterProp="label" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">O'zgartirish</Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Edit;